(function () {
    'use strict';

    angular
        .module('planInitiativeEditModule')
        .controller('DeliverableEditController', Controller);

    Controller.$inject = ['$scope', '$state', 'initiative', 'deliverable'];

    function Controller($scope, $state, initiative, deliverable) {
        $scope.initiative = initiative;
        $scope.deliverable = deliverable;

        $scope.goToDeliverables = function () {
            $state.go('initiative.edit.deliverable');
        };

        $scope.goToPlanInitiative = function () {
            $state.go('initiative.edit');
        };

        $scope.goToDeliverable = function (deliverable) {
            $state.go('initiative.edit.deliverable.edit', {
                PlanDeliverableID: deliverable.PlanDeliverableID
            });
        };
    }
})();